export default __webpack_public_path__ + "static/media/email.60d44adc.svg";